import React from 'react';
import Container from '@/components/container';
import { withRouter } from 'react-router-dom';
import './index.less';

function noPower(props) {
  return (
    <Container>
      <div className="no-Power-wrap">
        <img
          src="//img12.360buyimg.com/imagetools/jfs/t1/161263/21/26390/64605/61a049a2E5e4e63f6/3b0847cf0e27eb66.png"
          width={276}
          height={138}
        />
        <div className="not-Power-des">抱歉！您没有当前页面的查看权限！</div>
        <div className="not-Power-button" onClick={() => props.history.push('/')}>
          返回首页
        </div>
      </div>
    </Container>
  );
}

export default withRouter(noPower);
